var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhatsappLogo = function SvgWhatsappLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whatsappLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsappLogo_svg__b)",
    d: "M.819 16.689c-.001 2.763.721 5.46 2.094 7.839L.688 32.653l8.314-2.18a15.7 15.7 0 0 0 7.495 1.908h.007c8.644 0 15.681-7.034 15.685-15.68a15.58 15.58 0 0 0-4.59-11.093A15.59 15.59 0 0 0 16.504 1.01C7.859 1.01.822 8.043.819 16.689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsappLogo_svg__c)",
    d: "M.261 16.685c0 2.862.747 5.657 2.17 8.12L.124 33.22l8.613-2.258a16.24 16.24 0 0 0 7.764 1.977h.007c8.954 0 16.244-7.287 16.248-16.242a16.14 16.14 0 0 0-4.755-11.491A16.15 16.15 0 0 0 16.509.443C7.553.443.265 7.73.261 16.685m5.13 7.696-.322-.51a13.46 13.46 0 0 1-2.064-7.185c.003-7.444 6.06-13.5 13.51-13.5a13.42 13.42 0 0 1 9.546 3.96 13.42 13.42 0 0 1 3.952 9.55c-.003 7.444-6.06 13.5-13.504 13.5h-.005a13.5 13.5 0 0 1-6.874-1.881l-.493-.293-5.111 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.445 9.894c-.304-.675-.624-.69-.914-.701-.236-.01-.507-.01-.778-.01-.27 0-.71.102-1.082.508S8.25 11.08 8.25 13.077s1.455 3.928 1.658 4.199 2.808 4.5 6.934 6.128c3.43 1.352 4.128 1.083 4.872 1.015.744-.067 2.402-.982 2.74-1.93s.338-1.76.237-1.93-.372-.27-.778-.473-2.402-1.186-2.774-1.321c-.372-.136-.643-.203-.914.203-.27.406-1.048 1.32-1.285 1.591-.237.272-.474.305-.88.102s-1.713-.632-3.264-2.014c-1.207-1.076-2.022-2.405-2.259-2.812-.237-.406-.025-.626.178-.828.183-.182.407-.474.61-.711.202-.237.27-.406.405-.677.136-.27.068-.508-.034-.711-.101-.203-.89-2.21-1.251-3.014"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsappLogo_svg__b",
    x1: 1575.75,
    x2: 1575.75,
    y1: 3165.31,
    y2: 1.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsappLogo_svg__c",
    x1: 1631.7,
    x2: 1631.7,
    y1: 3278.21,
    y2: 0.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsappLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.125.443h32.632V33.33H.125z"
  })))));
};
export default SvgWhatsappLogo;